import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2e8f4d46&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e8f4d46')) {
      api.createRecord('2e8f4d46', component.options)
    } else {
      api.reload('2e8f4d46', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2e8f4d46&", function () {
      api.rerender('2e8f4d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/roles/Index.vue"
export default component.exports